import * as React from 'react';

import { Wrapper } from './styles';
import ButtonCombine from '../../../ButtonCombine';
import ButtonRemoveSpread from '../../../../../containers/Editor/ButtonRemoveSpread';
import ButtonDuplicateSpread from '../../../../../containers/Editor/ButtonDuplicateSpread';

interface ButtonsPanelProps {
	isButtonDuplicateDisplayed: boolean;
	isButtonRemoveDisplayed: boolean;
}

const ButtonsPanel = ({ isButtonDuplicateDisplayed, isButtonRemoveDisplayed }: ButtonsPanelProps) => {
	return (
		<Wrapper>
			{isButtonDuplicateDisplayed && <ButtonDuplicateSpread />}
			<ButtonCombine />
			{isButtonRemoveDisplayed && <ButtonRemoveSpread />}
		</Wrapper>
	);
};

export default ButtonsPanel;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Thumbnails/Column/ButtonsPanel/index.tsx